import React from "react";
import { FaRegSmile, FaRegFrown } from "react-icons/fa";

const IndicatorsCounts = ({numberTotal, goodNumbers, badNumbers}) => {
  return (
    <div className="flex flex-wrap justify-center items-center">
      <div className="flex flex-col items-center justify-center">
        <div className="flex flex-col items-center justify-center bg-gray-100 p-4 m-4 drop-shadow-lg w-48 h-40 text-center font-semibold rounded-lg border border-opacity-45">
          <p className="text-sm text-blue-950">Quantidade de indicadores </p>
          <p className="text-sm text-blue-950 mb-2">aplicados</p>
          <p className="text-6xl text-blue-950 font-bold mb-2">{numberTotal.toString().padStart(2, "0")}</p>
        </div>
      </div>
      <div className="flex flex-col items-center justify-center">
        <div className="flex flex-col items-center justify-center bg-gray-100 p-4 m-4 drop-shadow-lg w-48 h-40 text-center font-semibold rounded-lg border border-opacity-45">
          <p className="text-sm mb-2 text-emerald-700">Quantidade de indicadores adequados</p>
          <p className="text-6xl font-bold mb-2 text-emerald-700">{goodNumbers.toString().padStart(2, "0")}</p>
          <div className="p-2 bg-emerald-700 rounded-full absolute bottom-2 right-2">
            <FaRegSmile className="text-2xl text-white" />
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center justify-center">
        <div className="flex flex-col items-center justify-center bg-gray-100 p-4 m-4 drop-shadow-lg w-48 h-40 text-center font-semibold rounded-lg border border-opacity-45">
          <p className="text-sm mb-2 text-yellow-600">Quantidade de indicadores que necessitam de atenção</p>
          <p className="text-6xl font-bold mb-2 text-yellow-600">{badNumbers.toString().padStart(2, "0")}</p>
          <div className="p-2 bg-yellow-600 rounded-full absolute bottom-2 right-2">
            <FaRegFrown className="text-2xl text-white"/>
          </div>
        </div>
      </div>
    </div>

  );
}

export default IndicatorsCounts;